var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialogModel',{attrs:{"title":"信用评价信息购买","visible":_vm.dialogPurchase},on:{"update:visible":function($event){_vm.dialogPurchase=$event},"handleClose":_vm.handleClosePurchase,"handleOk":_vm.handlePurchase}},[_c('div',{staticClass:"main-body"})])
}
var staticRenderFns = []

export { render, staticRenderFns }